import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { QueryClient } from '@tanstack/react-query';
import { Skeleton } from 'antd';
import { BlockNames } from './block.types';

export function addBlocks(piral: PiletApi, queryClient: QueryClient) {
	const LazyConversationViewer = React.lazy(() => import('./ConversationViewer'));
	piral.registerExtension(BlockNames.Viewer, props => (
		<React.Suspense fallback={<Skeleton active />}>
			<LazyConversationViewer
				piral={piral}
				params={{ ...props.params, piletApi: piral, queryClient }}
			/>
		</React.Suspense>
	));
}
